import React from 'react';

export const EXPENSE_CATEGORIES = [
  { value: 'food', label: 'Food & Drinks' },
  { value: 'venue', label: 'Venue' },
  { value: 'travel', label: 'Travel' },
  { value: 'lodging', label: 'Lodging' },
  { value: 'decorations', label: 'Decorations' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'supplies', label: 'Supplies' },
  { value: 'other', label: 'Other' },
];

export const EMPTY_EXPENSE = { description: '', amount: '', paid_by: '', category: 'other', status: 'planned' };

const inputCls = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent';

function StatusToggle({ value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="expense-status-toggle">
      {[{ v: 'planned', l: 'Planned' }, { v: 'paid', l: 'Paid' }].map(({ v, l }) => (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          className={`py-2 rounded-lg border text-sm font-medium transition-colors ${value === v ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
          data-testid={`expense-status-${v}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

export function ExpenseModal({ mode = 'add', expenseData, setExpenseData, familyMembers, onSubmit, onClose, saving }) {
  const isEdit = mode === 'edit';
  const isPaid = expenseData.status === 'paid';
  const set = (field) => (e) => setExpenseData({ ...expenseData, [field]: e.target.value });
  const memberNames = familyMembers.map((m) => m.name);
  const showLegacyPayer = expenseData.paid_by && !memberNames.includes(expenseData.paid_by);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto" data-testid="expense-modal">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">{isEdit ? 'Edit Expense' : 'Add Expense'}</h3>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Description</label>
            <input type="text" value={expenseData.description} onChange={set('description')} className={inputCls} required data-testid="expense-description-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-gray-700 font-medium mb-2">Amount ($)</label>
              <input type="number" step="0.01" min="0" value={expenseData.amount} onChange={set('amount')} className={inputCls} required data-testid="expense-amount-input" />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2">Category</label>
              <select value={expenseData.category} onChange={set('category')} className={inputCls} data-testid="expense-category-select">
                {EXPENSE_CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Status</label>
            <StatusToggle value={expenseData.status} onChange={(status) => setExpenseData({ ...expenseData, status })} />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">{isPaid ? 'Paid By' : 'Who will pay (optional)'}</label>
            <select value={expenseData.paid_by} onChange={set('paid_by')} className={inputCls} required={isPaid} data-testid="expense-paid-by-select">
              <option value="">{isPaid ? 'Select who paid' : 'Not decided yet'}</option>
              {showLegacyPayer && <option value={expenseData.paid_by}>{expenseData.paid_by}</option>}
              {familyMembers.map((member) => <option key={member.user_id} value={member.name}>{member.name}</option>)}
            </select>
          </div>
          <div className="flex space-x-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-testid="cancel-expense-btn">
              Cancel
            </button>
            <button type="submit" disabled={saving} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-60" data-testid="submit-expense-btn">
              {saving ? 'Saving...' : isEdit ? 'Save Changes' : 'Add Expense'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
